import NewHeaderNavWithSidebar from '../components/HeaderNav/NewHeaderNavWithSidebar';
import * as React from "react";
import { useState, useEffect } from "react";
import { extendTheme, styled, useTheme } from "@mui/material/styles";
import { useUser } from "../context/UserContext";

import FavoriteIcon from "@mui/icons-material/Favorite";
import { AppProvider } from "@toolpad/core/AppProvider";
import { DashboardLayout } from "@toolpad/core/DashboardLayout";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import { createTheme } from "@mui/material/styles";
import {
  Avatar,
  Badge,
  Box,
  Button,
  Dialog,
  DialogContent,
  Divider,
  Menu,
  useMediaQuery,
} from "@mui/material";
import { useActivePage } from "@toolpad/core/useActivePage";
import About from "./SidebarPages/AboutUs";
import ListPlots from "./ListPlots";
import PlansPricing from "./PlansPricing";
import Profile from "./Profile";
import Wishlist from "./SidebarPages/Wishlist";
import Settings from "./SidebarPages/Settings";
import Support from "./SidebarPages/Support";
import Home from "./Home";
import AdminHome from "./AdminPages/AdminHome";
import Search from "./Search";
import {
  FeaturedPlayListRounded,
  Logout,
  Moving,
  AccountCircle,
  SupportAgent,
  GTranslate,
  GavelRounded,
  ShieldRounded,
  QuizRounded,
  SupportAgentRounded,
  InfoRounded,
  SettingsRounded,
  ShoppingBagRounded,
  PageviewRounded,
  FavoriteRounded,
  CardMembershipRounded,
  DashboardRounded,
  CropRounded,
  PersonRounded,
  SearchRounded,
  Contacts,
  AccessTime,
  Close,
  SpeakerNotes,
  LocalShipping,
  GppBad,
  Language,
  AgricultureRounded,
  CloudQueueRounded,
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ManagePlans from "./AdminPages/ManagePlans";
import ListBuyers from "./AdminPages/ListBuyers";
import ListSellers from "./AdminPages/ListSellers";
import Popover from "@mui/material/Popover";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import { fonts, colors, size } from "../ColorFont/color";
import { signOut } from "firebase/auth";
import "../assets/css/style.css";
import ViewedPlots from "./ViewedPlots";
import PurchasedPlans from "./PurchasedPlans";
import ManageCropCategory from "./AdminPages/ManageCropCategory";
import { admin, url } from "../ConstUrl/Url";
import PurchasedPlansSeller from "./PurchasedPlansSeller";
import SignUp from "../auth/SignUp";
import LanguageSelector from "../language/LanguageSelector";
import FreePlans from "./AdminPages/FreePlans";
import ManageDashboard from "./AdminPages/ManageDashboard";
import SearchBar from "./SearchBar";
import TermsAndCondition from "./SidebarPages/TermsAndConditions";
import PrivacyPolicy from "./SidebarPages/PrivacyPolicy";
import FAQs from "./SidebarPages/FAQs";
import CarbonCreditsDashboard from "../screens/CarbonCreditsScreen/CarbonCreditsDashboard";
import CarbonCreditsFarmDetails from "../screens/CarbonCreditsScreen/CarbonCreditsFarmDetails";
import CarbonCreditsPractices from "../screens/CarbonCreditsScreen/CarbonCreditsPractices";
import CarbonCreditsTimeline from "../screens/CarbonCreditsScreen/CarbonCreditsTimeline";
import CarbonCreditsReview from "../screens/CarbonCreditsScreen/CarbonCreditsReview";
import CarbonCreditsUploadProof from "../screens/CarbonCreditsScreen/CarbonCreditsUploadProof";
import CarbonCreditsMyWallet from "../screens/CarbonCreditsScreen/CarbonCreditsMyWallet";
import CarbonCreditsManageProofs from "./AdminPages/CarbonCreditsManageProofs";
import CropCategory from "../screens/CropListing/CropCategory";
import MyCrops from "../screens/CropListing/MyCrops";
import Pricing from "../screens/CropListing/Pricing";
import Photos from "../screens/CropListing/Photos";
import LocationDelivery from "../screens/CropListing/LocationDelivery";
import { fontThemes } from "../ColorFont/fontTheme";
import { themes } from "../ColorFont/themes";
import RefundPolicy from "./SidebarPages/RefundPolicy";
import ShippingPolicy from "./SidebarPages/ShippingPolicy";
import CancellationPolicy from "./SidebarPages/CancellationPolicy";
import { KrushiSetu } from "../constants/constant";


// function ToolbarActionsSearch({
//   onSearchInputClick,
//   keyword,
//   setKeyword,
//   isAutoFocusSearchOn,
//   onUpgradePlansClick,
//   onWishlistClick,
//   userProfilePage,
//   userSupporPage,
//   userData,
//   onContactClick,
//   onHoursClick,
// }) {
//   const inputRef = React.useRef(null);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
// 
//   const navigate = useNavigate();
//   const { t } = useTranslation();
//   const [userDetails, setUserDetails] = useState(null);
//   const [userDataMongoDb, setUserDataMongoDb] = useState(null);
//   const [showFavBtn, setShowFavBtn] = useState(false);
//   const [open, setOpen] = useState(false);
//   const [isOpen, setIsOpen] = useState(false);
//   const [totalPlots, setTotalPlots] = useState(null);
//   const [role, setRole] = useState(null);
//   const adminEmail = `${admin}`; //set up for admin email
//   const [wishlistCount, setWishlistCount] = useState(0);
//   const [placeholderIndex, setPlaceholderIndex] = useState(0);
//   const [anchorEl, setAnchorEl] = React.useState(null); // State to manage dropdown anchor
//   const [isRoleSelectionActive, setIsRoleSelectionActive] = useState(false); // Track if Role Selection is active
// 
//   const placeholders = [t("newPlot"), t("whatNeed"), t("new")];
// 
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setPlaceholderIndex((prevIndex) => (prevIndex + 1) % placeholders.length);
//     }, 1000); // Change placeholder every 3 seconds
// 
//     return () => clearInterval(interval);
//   }, []);
// 
//   useEffect(() => {
//     if (userDataMongoDb) {
//       setWishlistCount(userDataMongoDb.wishlist.length);
//     }
//   }, [userDataMongoDb]);
// 
//   useEffect(() => {
//     const unsubscribe = auth.onAuthStateChanged((user) => {
//       if (user) {
//         //userdetails have Firebase data
//         setUserDetails({
//           username: user.displayName || "User",
//           email: user.email || "N/A",
//           phoneNumber: user.phoneNumber || "N/A",
//           photoURL: user.photoURL,
//         });
//         const identifier = user?.email || user?.phoneNumber;
// 
//         fetch(`${url}/api/user-data/${encodeURIComponent(identifier)}`)
//           .then((response) => {
//             if (response.ok) {
//               return response.json();
//             } else {
//               throw new Error("Failed to fetch user data.");
//             }
//           })
//           .then((data) => {
//             setUserDataMongoDb(data);
//             const role = data?.role;
//             setRole(role);
//             if (role == "Buyer") {
//               setShowFavBtn(true);
//             } else if (role == "Seller") {
//               setShowFavBtn(false);
//             }
//           })
//           .catch((error) => console.error("Error:", error));
//       } else {
//         setUserDetails(null);
//       }
//     });
//     fetchcount();
// 
//     return () => unsubscribe();
//   }, []);
// 
//   const fetchcount = async () => {
//     if (!userDetails) {
//     } else {
//       try {
//         const response = await fetch(
//           `${url}/api/wishlist/count/${userDetails?.email}`
//         );
// 
//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }
// 
//         const data = await response.json();
//         setTotalPlots(data?.wishlistCount);
//       } catch (error) { }
//     }
//   };
// 
//   const handleOpen = () => {
//     setOpen(true);
//   };
// 
//   const handleOpenLanguage = (event) => {
//     setIsOpen(true);
//     setAnchorEl(event.currentTarget);
//   };
// 
//   const handleCloseLanguage = () => {
//     setIsOpen(false);
//     setAnchorEl(null);
//   };
// 
//   const handleClose = () => {
//     setOpen(false);
//   };
// 
//   const handleSignOut = async () => {
//     try {
//       await signOut(auth);
//       window.location.reload();
// 
//       navigate("/home");
//     } catch (error) { }
//   };
// 
//   if (!userDetails) {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: "row",
//           alignItems: "center",
//           gap: 1,
//         }}
//       >
//         <Tooltip title="Search" enterDelay={1000}>
//           <div>
//             <TextField
//               // label={t("search")}
//               variant="outlined"
//               size="small"
//               color="success" // Using the MUI 'success' color variant, or you can manually set it to #01AA4F
//               value={keyword}
//               onClick={() => {
//                 onSearchInputClick();
//               }}
//               autoFocus={isAutoFocusSearchOn}
//               onChange={(e) => {
//                 onSearchInputClick();
//                 setKeyword(e.target.value);
//               }}
//               inputRef={inputRef}
//               placeholder={t("searchHere")} // Placeholder text for the search bar
//               sx={{
//                 width: "100px",
//                 display: { xs: "block", md: "none" },
//               }} // Adjust the width here
//               slotProps={{
//                 input: {
//                   endAdornment: (
//                     <SearchIcon sx={{ color: colors.primary_dark }} />
//                   ),
//                 },
//               }}
//             />
//           </div>
//         </Tooltip>
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "row",
//             justifyContent: "flex-start",
//           }}
//         >
//           <TextField
//             // label={t("search")}
//             variant="outlined"
//             size="small"
//             color="success" // Using the MUI 'success' color variant, or you can manually set it to #01AA4F
//             value={keyword}
//             onClick={() => {
//               onSearchInputClick();
//             }}
//             autoFocus={isAutoFocusSearchOn}
//             onChange={(e) => {
//               onSearchInputClick();
//               setKeyword(e.target.value);
//             }}
//             inputRef={inputRef}
//             placeholder={t("searchHere")} // Placeholder text for the search bar
//             slotProps={{
//               input: {
//                 endAdornment: (
//                   <IconButton type="button" aria-label="search" size="small">
//                     <SearchIcon sx={{ color: colors.primary_dark }} />{" "}
//                     {/* Color of the search icon */}
//                   </IconButton>
//                 ),
//                 sx: {
//                   pr: 0.5,
//                   width: "300px",
//                   borderRadius: 2, // Adding a rounded border radius
//                   transition: "all 0.3s ease-in-out", // Smooth transition effect on focus
//                   "&:focus": {
//                     borderColor: colors.primary_dark, // Focus border color
//                     boxShadow: "0 0 0 2px rgba(1, 170, 79, 0.3)", // Adding subtle glow on focus
//                   },
//                 },
//               },
//             }}
//             sx={{
//               display: { xs: "none", md: "inline-block" },
//               mr: 1,
//               borderRadius: "30px", // Applying same border radius to the textfield container
//               "& .MuiOutlinedInput-root": {
//                 "& fieldset": {
//                   borderColor: colors.primary_dark, // Border color when not focused
//                 },
//                 "&:hover fieldset": {
//                   borderColor: colors.primary_dark, // Hover effect
//                 },
//               },
//             }}
//           />
//         </Box>
// 
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "row",
//             alignItems: "center",
//             gap: 1,
//           }}
//         >
//           <Divider orientation="vertical" flexItem />
//           <Box sx={{ position: "relative" }}>
//             <Tooltip title="Change Language">
//               <IconButton
//                 onClick={handleOpenLanguage}
//                 sx={{
//                   color: colors.primary_dark,
//                   background: "rgba(58, 123, 213, 0.1)",
//                   "&:hover": {
//                     background: "rgba(58, 123, 213, 0.2)",
//                     transform: "rotate(12deg)",
//                   },
//                   transition: "all 0.3s ease",
//                   // p: 1.5,
//                 }}
//               >
//                 <Language />
//               </IconButton>
//             </Tooltip>
// 
//             <Menu
//               anchorEl={anchorEl}
//               open={Boolean(anchorEl)}
//               onClose={handleCloseLanguage}
//               PaperProps={{
//                 sx: {
//                   width: 300,
//                   maxHeight: "none",
//                   overflow: "visible",
//                   borderRadius: 4,
//                   boxShadow: "0 12px 40px rgba(0, 0, 0, 0.15)",
//                   border: "1px solid rgba(0, 0, 0, 0.05)",
//                   mt: 1.5,
//                   "&:before": {
//                     content: '""',
//                     display: "block",
//                     position: "absolute",
//                     top: -10,
//                     right: 20,
//                     width: 20,
//                     height: 20,
//                     bgcolor: "background.paper",
//                     transform: "rotate(45deg)",
//                     zIndex: 0,
//                     borderTop: "1px solid rgba(0, 0, 0, 0.05)",
//                     borderLeft: "1px solid rgba(0, 0, 0, 0.05)",
//                   },
//                 },
//               }}
//               anchorOrigin={{
//                 vertical: "bottom",
//                 horizontal: "right",
//               }}
//               transformOrigin={{
//                 vertical: "top",
//                 horizontal: "right",
//               }}
//             >
//               <LanguageSelector />
//             </Menu>
//           </Box>
//           {userData?.role == "Buyer" && (
//             <>
//               <Divider orientation="vertical" flexItem />
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: "row",
//                   justifyContent: "center",
//                   alignItems: "center",
//                 }}
//               >
//                 <Tooltip title="Wishlist">
//                   <Badge
//                     badgeContent={userDataMongoDb?.wishlist?.length}
//                     sx={{
//                       "& .MuiBadge-badge": {
//                         fontSize: "10px", // Adjust font size
//                         height: "16px", // Reduce height
//                         minWidth: "16px", // Reduce width
//                         padding: "0 4px", // Adjust padding for a better fit
//                         background: "#C91A1A",
//                         color: "white",
//                       },
//                     }}
//                   >
//                     <IconButton
//                       onClick={handleOpenLanguage}
//                       sx={{
//                         color: colors.primary_dark,
//                         background: "rgba(58, 123, 213, 0.1)",
//                         "&:hover": {
//                           background: "rgba(58, 123, 213, 0.2)",
//                           transform: "rotate(12deg)",
//                         },
//                         transition: "all 0.3s ease",
//                         // p: 1.5,
//                       }}
//                     >
//                       <FavoriteIcon onClick={() => onWishlistClick()} />
//                     </IconButton>
//                   </Badge>
//                 </Tooltip>
//               </Box>
//             </>
//           )}
//           <Divider orientation="vertical" flexItem />
// 
//           <Box sx={{ display: "flex", alignItems: "center" }}>
//             {!isMobile && (
//               <Tooltip title="Plans">
//                 <Button
//                   variant="contained"
//                   sx={{
//                     backgroundImage: colors.button,
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     fontFamily: fonts.poppins,
//                     borderRadius: 2,
//                     padding: "6px 12px",
//                     fontSize: size.text,
//                     textTransform: "none",
//                   }}
//                   onClick={onUpgradePlansClick}
//                 >
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//                     {t("upgrade")}
//                     <img
//                       src="crown.png"
//                       alt="logo"
//                       height="20px"
//                       width="20px"
//                     />
//                   </Box>
//                 </Button>
//               </Tooltip>
//             )}
// 
//             {!isMobile && <Divider orientation="vertical" />}
//           </Box>
//           <Box>
//             <Typography
//               onClick={handleOpen}
//               sx={{
//                 fontFamily: "fonts.poppins",
//                 fontSize: isMobile ? "0.7rem" : "0.8rem", // Smaller on mobile
//                 fontWeight: 600,
//                 color: "#388e3c",
//                 // bgcolor: colors.background_light, // Lighter background color
//                 p: isMobile
//                   ? "0.3rem 0.8rem 0.3rem 1.5rem"
//                   : "0.5rem 1rem 0.5rem 1.8rem",
//                 borderRadius: "6px",
//                 border: `1px solid ${colors.primary_dark}`,
//                 position: "relative",
//                 cursor: "pointer",
//                 transition: "transform 0.2s",
//                 "&:hover": {
//                   transform: isMobile ? "none" : "scale(1.03)", // Disable hover effect on mobile
//                   bgcolor: colors.background_light, // Change background color on hover
//                 },
//                 "&:before": {
//                   content: '"🌱"',
//                   position: "absolute",
//                   left: isMobile ? "0.5rem" : "0.6rem",
//                   fontSize: isMobile ? "0.6rem" : "0.7rem",
//                 },
//               }}
//             >
//               {t("login")}
//             </Typography>
//             {/* OLD CODE — Dialog with old Paper styling inside dialog
//             <Dialog open={open} onClose={handleClose} fullWidth maxWidth={false}
//               PaperProps={{ sx: { width: { xs: "90%", sm: "70%", md: "50%" }, maxWidth: "600px", height: "auto", maxHeight: "90vh", margin: "auto", overflow: "auto", borderRadius: 5, position: "relative" } }}
//             >
//               ... (original content inside) ...
//             </Dialog>
//             */}
// 
//             {/* NEW UPDATED CODE — Figma full-screen layout */}
//             <Dialog
//               open={open}
//               onClose={handleClose}
//               fullScreen
//               PaperProps={{
//                 sx: {
//                   // Figma: background always #FCFDFC (hardcoded — login page is always Figma-themed)
//                   backgroundColor: "#FCFDFC",
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   justifyContent: "flex-start", // Changed from center to allow natural scrolling with margins
//                   position: "relative",
//                   overflow: "auto",
//                   py: { xs: 4, sm: '3vh' }, // Used vh mapping to compress on small height screens
//                 },
//               }}
//             >
//               {/* ===== UNIVERSAL TOKENS ===== */}
//               {/* 
//                 Colors: colors.text (#6D786D), colors.text_dark (#171C17), colors.border (#E3E8E3), colors.light (#FFFFFF)
//                 Typography: size.h1 (30px), size.body (16px), size.small (14px)
//                 Shadows: colors.shadow_card
//                 Border Radius: 32px
//               */}
// 
//               {/* ===== OLD UI (Commented) ===== */}
//               {/* 
//               <IconButton ...> ... </IconButton>
//               <Box ...> ... Logo, Title, Card, Footer ... </Box>
//               */}
// 
//               {/* ===== NEW FIGMA UI ===== */}
// 
//               {/* Close Icon Button */}
//               <IconButton
//                 aria-label="close"
//                 onClick={handleClose}
//                 sx={{
//                   position: "fixed",
//                   right: 16,
//                   top: 16,
//                   zIndex: 10,
//                   color: colors.text,
//                   backgroundColor: "rgba(255,255,255,0.8)",
//                   backdropFilter: "blur(4px)",
//                   "&:hover": { backgroundColor: "rgba(255,255,255,0.95)" },
//                 }}
//               >
//                 <Close />
//               </IconButton>
// 
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   justifyContent: "flex-start",
//                   width: {
//                     xs: "100%", // full width responsive mobile percentages
//                     sm: isRoleSelectionActive ? "32rem" : "28rem" // rem sizes instead of pixels
//                   },
//                   maxWidth: '100%',
//                   px: { xs: '1rem', sm: 0 }, // mobile x-padding rem based
//                   my: "auto",
//                   transition: "all 0.3s ease-in-out",
//                 }}
//               >
//                 {/* Header (Logo + Title) hidden during Role Selection */}
//                 {!isRoleSelectionActive && (
//                   <>
//                     {/* Logo Icon */}
//                     <Box
//                       component="img"
//                       src="Icon krushisetu.png"
//                       alt="KrushiSetu Logo"
//                       sx={{
//                         width: "clamp(4rem, 8vh, 5rem)", // clamp height based sizing
//                         height: "clamp(4rem, 8vh, 5rem)",
//                         objectFit: "contain",
//                       }}
//                     />
// 
//                     {/* Title: KrushiSetu */}
//                     <Typography
//                       sx={{
//                         fontFamily: fonts.poppins,
//                         fontWeight: 700,
//                         fontSize: size.h1, // 30px clamp
//                         lineHeight: 1.2,
//                         letterSpacing: "-0.046rem",
//                         color: colors.text_dark, // #171C17
//                         textAlign: "center",
//                         mt: "clamp(0.5rem, 2vh, 1rem)", // fluid margin
//                       }}
//                     >
//                       KrushiSetu
//                     </Typography>
// 
//                     {/* Tagline: India's Trusted Agri Bridge */}
//                     <Typography
//                       sx={{
//                         width: "100%", // percentage limits
//                         maxWidth: "17.5rem", // 280px -> rems
//                         fontFamily: fonts.poppins,
//                         fontWeight: 400,
//                         fontSize: size.body, // 16px clamp
//                         lineHeight: 1.5,
//                         color: colors.text, // #6D786D
//                         textAlign: "center",
//                         mt: "clamp(0.25rem, 1vh, 0.5rem)", // fluid margin
//                       }}
//                     >
//                       {t("home-title")}
//                     </Typography>
//                   </>
//                 )}
// 
//                 {/* Card Container */}
//                 <Box
//                   sx={{
//                     width: "100%", // percentages
//                     minHeight: isRoleSelectionActive ? "40rem" : "18rem", // 600px/286px -> rem scale
//                     backgroundColor: isRoleSelectionActive ? "transparent" : colors.light, // #FFFFFF
//                     border: isRoleSelectionActive ? "none" : `1px solid ${colors.border}`, // #E3E8E3
//                     boxShadow: isRoleSelectionActive ? "none" : colors.shadow_card,
//                     borderRadius: "2rem", // 32px
//                     transition: "all 0.3s ease-in-out",
//                     mt: { xs: '1.5rem', sm: 'clamp(1rem, 4vh, 2.5rem)' }, // vh responsive margins
//                     px: { xs: '1.5rem', sm: '2rem' }, // padding rems
//                     pt: { xs: '1.5rem', sm: 'clamp(1.5rem, 4vh, 2rem)' },
//                     pb: { xs: '1.5rem', sm: 'clamp(1.5rem, 4vh, 2rem)' },
//                   }}
//                 >
//                   <DialogContent sx={{ p: 0, overflow: "visible", width: '100%' }}>
//                     <SignUp onRoleSelectionChange={setIsRoleSelectionActive} />
//                   </DialogContent>
//                 </Box>
// 
//                 {/* Terms and Privacy Footer: below the card */}
//                 {!isRoleSelectionActive && (
//                   <Box
//                     sx={{
//                       width: "100%",
//                       display: "flex",
//                       justifyContent: "center",
//                       alignItems: "center",
//                       mt: { xs: 3, sm: 4 },
//                     }}
//                   >
//                     <Typography
//                       sx={{
//                         fontSize: size.small, // 14px
//                         lineHeight: "20px",
//                         fontWeight: 400,
//                         color: colors.text, // #6D786D
//                         fontFamily: fonts.poppins,
//                         textAlign: "center",
//                         display: "flex",
//                         flexWrap: "wrap",
//                         justifyContent: "center",
//                         alignItems: "center",
//                         gap: "4px"
//                       }}
//                     >
//                       {t("byContinuing")}
//                       <span
//                         style={{ color: colors.primary, cursor: "pointer", textDecoration: "underline" }}
//                         onClick={() => navigate("/terms-conditions")}
//                       >
//                         {t("terms")}
//                       </span>
//                       {t("and")}
//                       <span
//                         style={{ color: colors.primary, cursor: "pointer", textDecoration: "underline" }}
//                         onClick={() => navigate("/privacy-policy")}
//                       >
//                         {t("privacy")}
//                       </span>
//                     </Typography>
//                   </Box>
//                 )}
//               </Box>
// 
//               {/* ===== UPDATED CSS (Tokens used in SX) ===== */}
// 
//             </Dialog>
//           </Box>
//         </Box>
//       </Box>
//     );
//   }
// 
//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "row",
//         alignItems: "center",
//         gap: 1,
//       }}
//     >
//       <Tooltip title="Search" enterDelay={1000}>
//         <div>
//           <TextField
//             // label={t("search")}
//             variant="outlined"
//             size="small"
//             color="success" // Using the MUI 'success' color variant, or you can manually set it to #01AA4F
//             value={keyword}
//             onClick={() => {
//               onSearchInputClick();
//             }}
//             autoFocus={isAutoFocusSearchOn}
//             onChange={(e) => {
//               onSearchInputClick();
//               setKeyword(e.target.value);
//             }}
//             inputRef={inputRef}
//             placeholder={t("searchHere")} // Placeholder text for the search bar
//             sx={{
//               width: "100px",
//               display: { xs: "block", md: "none" },
//             }} // Adjust the width here
//             slotProps={{
//               input: {
//                 endAdornment: (
//                   <IconButton type="button" aria-label="search" size="small">
//                     <SearchIcon sx={{ color: colors.primary_dark }} />{" "}
//                     {/* Color of the search icon */}
//                   </IconButton>
//                 ),
//               },
//             }}
//           />
//         </div>
//       </Tooltip>
// 
//       {!isMobile && (
//         <>
//           {userDataMongoDb?.role === "Buyer" && (
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1,
//                 padding: "6px 12px",
//                 borderRadius: 2,
//                 backgroundColor: "#ffffff",
//                 border: `1px solid ${colors.primary_dark}`,
//               }}
//             >
//               <Contacts sx={{ color: colors.primary_dark, fontSize: 20 }} />
//               <Typography
//                 sx={{
//                   fontFamily: fonts.poppins,
//                   fontSize: size.label,
//                   color: "#333",
//                   fontWeight: 500,
//                   whiteSpace: "nowrap",
//                 }}
//                 onClick={() => {
//                   onContactClick();
//                 }}
//               >
//                 {t("contacts")}:
//               </Typography>
//               <Typography
//                 sx={{
//                   fontFamily: fonts.poppins,
//                   fontSize: size.label,
//                   fontWeight: "bold",
//                   color: colors.primary_dark,
//                   cursor: "pointer",
//                 }}
//               >
//                 {userDataMongoDb?.noOfContacts || 0}
//               </Typography>
//             </Box>
//           )}
// 
//           {userDataMongoDb?.role === "Seller" && (
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1,
//                 padding: "6px 12px",
//                 borderRadius: 2,
//                 backgroundColor: "#ffffff",
//                 border: `1px solid ${colors.primary_dark}`,
//               }}
//             >
//               <AccessTime sx={{ color: colors.primary_dark, fontSize: 20 }} />
//               <Typography
//                 sx={{
//                   fontFamily: fonts.poppins,
//                   fontSize: size.label,
//                   color: "black",
//                   cursor: "pointer",
//                   whiteSpace: "nowrap",
//                 }}
//                 onClick={() => {
//                   onHoursClick();
//                 }}
//               >
//                 {t("hours")}:
//               </Typography>
//               <Typography
//                 sx={{
//                   fontFamily: fonts.poppins,
//                   fontSize: size.label,
//                   fontWeight: "bold",
//                   color: colors.primary_dark,
//                 }}
//               >
//                 {userDataMongoDb?.sponseredHours || 0}
//               </Typography>
//             </Box>
//           )}
//         </>
//       )}
// 
//       <TextField
//         // label={t("search")}
//         variant="outlined"
//         size="small"
//         color="success" // Using the MUI 'success' color variant, or you can manually set it to #01AA4F
//         value={keyword}
//         onClick={() => {
//           onSearchInputClick();
//         }}
//         autoFocus={isAutoFocusSearchOn}
//         onChange={(e) => {
//           onSearchInputClick();
//           setKeyword(e.target.value);
//         }}
//         inputRef={inputRef}
//         placeholder={`${t("searchFor")} ${placeholders[placeholderIndex]}`} // Dynamic placeholder
//         slotProps={{
//           input: {
//             endAdornment: (
//               <IconButton type="button" aria-label="search" size="small">
//                 <SearchIcon sx={{ color: colors.primary_dark }} />{" "}
//                 {/* Color of the search icon */}
//               </IconButton>
//             ),
//             sx: {
//               // pr: 0.5,
//               width: "300px",
//               borderRadius: 2,
//               transition: "all 0.3s ease-in-out",
//               "&:focus": {
//                 borderColor: colors.primary_dark,
//                 boxShadow: "0 0 0 2px rgba(1, 170, 79, 0.3)",
//               },
//               "&::placeholder": {
//                 color: colors.primary_dark,
//                 opacity: 1,
//                 transition: "opacity 0.5s ease-in-out",
//               },
//             },
//           },
//         }}
//         sx={{
//           display: { xs: "none", md: "inline-block" },
//           mr: 1,
//           borderRadius: "30px", // Applying same border radius to the textfield container
//           "& .MuiOutlinedInput-root": {
//             "& fieldset": {
//               borderColor: colors.primary_dark, // Border color when not focused
//             },
//             "&:hover fieldset": {
//               borderColor: colors.primary_dark, // Hover effect
//             },
//           },
//         }}
//       />
// 
//       <Stack
//         sx={{
//           display: "flex",
//           flexDirection: "row",
//           justifyContent: "center",
//           alignItems: "center",
//           gap: 1,
//         }}
//       >
//         <Box sx={{ position: "relative" }}>
//           <Tooltip title="Change Language">
//             <IconButton
//               onClick={handleOpenLanguage}
//               sx={{
//                 color: colors.primary_dark,
//                 background: "rgba(58, 123, 213, 0.1)",
//                 "&:hover": {
//                   background: "rgba(58, 123, 213, 0.2)",
//                   transform: "rotate(12deg)",
//                 },
//                 transition: "all 0.3s ease",
//                 // p: 1.5,
//               }}
//             >
//               <Language />
//             </IconButton>
//           </Tooltip>
// 
//           <Menu
//             anchorEl={anchorEl}
//             open={Boolean(anchorEl)}
//             onClose={handleCloseLanguage}
//             PaperProps={{
//               sx: {
//                 width: 300,
//                 maxHeight: "none",
//                 overflow: "visible",
//                 borderRadius: 4,
//                 boxShadow: "0 12px 40px rgba(0, 0, 0, 0.15)",
//                 border: "1px solid rgba(0, 0, 0, 0.05)",
//                 mt: 1.5,
//                 "&:before": {
//                   content: '""',
//                   display: "block",
//                   position: "absolute",
//                   top: -10,
//                   right: 20,
//                   width: 20,
//                   height: 20,
//                   bgcolor: "background.paper",
//                   transform: "rotate(45deg)",
//                   zIndex: 0,
//                   borderTop: "1px solid rgba(0, 0, 0, 0.05)",
//                   borderLeft: "1px solid rgba(0, 0, 0, 0.05)",
//                 },
//               },
//             }}
//             anchorOrigin={{
//               vertical: "bottom",
//               horizontal: "right",
//             }}
//             transformOrigin={{
//               vertical: "top",
//               horizontal: "right",
//             }}
//           >
//             <LanguageSelector />
//           </Menu>
//         </Box>
//         {/* admin dashboard */}
// 
//         {userDetails.email !== adminEmail && (
//           <>
//             {showFavBtn && (
//               <>
//                 <Divider orientation="vertical" flexItem />
// 
//                 <Box>
//                   <Tooltip title="Wishlist">
//                     <Badge
//                       badgeContent={userDataMongoDb?.wishlist?.length}
//                       sx={{
//                         "& .MuiBadge-badge": {
//                           fontSize: "10px", // Adjust font size
//                           height: "16px", // Reduce height
//                           minWidth: "16px", // Reduce width
//                           padding: "0 4px", // Adjust padding for a better fit
//                           background: "#C91A1A",
//                           color: "white",
//                         },
//                       }}
//                     >
//                       <FavoriteIcon
//                         sx={{
//                           color: colors.primary_dark,
//                           cursor: "pointer",
//                           transition: "all 0.5s ease",
//                           "&:hover": {
//                             color: "#ff4081", // A vibrant pink (or choose another accent color)
//                             animation: "bounce 0.5s ease infinite alternate",
//                           },
//                           "@keyframes bounce": {
//                             "0%": { transform: "translateY(0) scale(1)" },
//                             "100%": {
//                               transform: "translateY(-5px) scale(1.1)",
//                             },
//                           },
//                         }}
//                         onClick={() => onWishlistClick()}
//                       />
//                     </Badge>
//                   </Tooltip>
//                 </Box>
//               </>
//             )}
//             <Divider orientation="vertical" flexItem />
// 
//             {!isMobile && (
//               <Tooltip title="Plans">
//                 <Button
//                   variant="contained"
//                   sx={{
//                     backgroundImage: colors.button,
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     fontFamily: fonts.poppins,
//                     borderRadius: 2,
//                     padding: "6px 12px",
//                     fontSize: size.text,
//                     textTransform: "none",
//                   }}
//                   onClick={onUpgradePlansClick}
//                 >
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//                     {t("upgrade")}
//                     <img
//                       src="crown.png"
//                       alt="logo"
//                       height="20px"
//                       width="20px"
//                     />
//                   </Box>
//                 </Button>
//               </Tooltip>
//             )}
//             {/* <Divider orientation="vertical" flexItem /> */}
//           </>
//         )}
// 
//         {userDetails && (
//           <PopupState variant="popover" popupId="demo-popup-popover">
//             {(popupState) => (
//               <>
//                 <Tooltip title="Profile">
//                   <Avatar
//                     src={
//                       `${url}/${userDataMongoDb?.profilePicture?.replace(/\\/g, "/")}` ||
//                       userDetails.photoURL
//                     }
//                     sx={{
//                       width: isMobile ? 36 : 40,
//                       height: isMobile ? 36 : 40,
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       cursor: "pointer",
//                       bgcolor: isMobile ? colors.primary_light : undefined, // Different background on mobile
//                       color: isMobile ? colors.primary_dark : undefined, // Different text color on mobile
//                       fontSize: isMobile ? "1.1rem" : "1.25rem",
//                       transition: "all 0.3s ease", // Smooth size transition
//                       "&:hover": {
//                         transform: isMobile ? "scale(1.05)" : "scale(1.1)",
//                       },
//                     }}
//                     {...bindTrigger(popupState)}
//                   >
//                     {isMobile && !userDetails.photoURL
//                       ? userDetails.username.substring(0, 2).toUpperCase() // Show 2 letters on mobile
//                       : userDetails.username.charAt(0).toUpperCase()}
//                   </Avatar>
//                 </Tooltip>
//                 <Popover
//                   {...bindPopover(popupState)}
//                   anchorOrigin={{
//                     vertical: "bottom",
//                     horizontal: isMobile ? "left" : "center", // Adjust anchor position on mobile
//                   }}
//                   transformOrigin={{
//                     vertical: "top",
//                     horizontal: isMobile ? "left" : "center",
//                   }}
//                   sx={{
//                     "& .MuiPaper-root": {
//                       border: `1px solid ${colors.primary_dark}`,
//                       borderRadius: 3,
//                       overflow: "hidden",
//                       width: isMobile ? "50vw" : undefined, // Constrain width on mobile
//                       maxWidth: isMobile ? "300px" : undefined, // Max width for mobile
//                     },
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: "flex",
//                       flexDirection: "column",
//                       justifyContent: "center",
//                       alignItems: "center",
//                       padding: isMobile ? 2 : 3,
//                       background: colors.background3,
//                     }}
//                   >
//                     <Avatar
//                       src={userDetails?.photoURL}
//                       sx={{
//                         width: isMobile ? 32 : 40,
//                         height: isMobile ? 32 : 40,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         marginBottom: 1,
//                       }}
//                     >
//                       {userDetails?.username.charAt(0).toUpperCase()}
//                     </Avatar>
//                     <Typography
//                       sx={{
//                         fontFamily: fonts.poppins,
//                         color: colors.primary_dark,
//                         fontWeight: 600,
//                         fontSize: isMobile ? size.smallText : size.text,
//                       }}
//                     >
//                       {userDetails?.username}
//                     </Typography>
//                     <Typography
//                       sx={{
//                         fontFamily: fonts.poppins,
//                         fontSize: isMobile ? 11 : 13,
//                         color: colors.primary_dark,
//                         textAlign: "center",
//                         wordBreak: "break-word", // Prevent long emails from overflowing
//                       }}
//                     >
//                       {userDetails?.email}
//                     </Typography>
// 
//                     <Typography
//                       sx={{
//                         fontFamily: fonts.poppins,
//                         fontSize: isMobile ? size.smallText : size.formLabel,
//                         color: colors.primary_dark,
//                       }}
//                     >
//                       {userDetails?.role}
//                     </Typography>
//                   </Box>
//                   <Divider />
// 
//                   <Box
//                     sx={{
//                       display: "flex",
//                       flexDirection: "column",
//                       justifyContent: "flex-start",
//                       padding: isMobile ? 2 : 3,
//                       gap: isMobile ? 1.5 : 2.5,
//                       background: colors.background3,
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: "flex",
//                         flexDirection: "row",
//                         alignItems: "center",
//                         gap: 1,
//                       }}
//                     >
//                       <AccountCircle
//                         sx={{
//                           color: colors.primary_dark,
//                           fontSize: isMobile ? "20px" : "24px",
//                         }}
//                       />
//                       <Typography
//                         sx={{
//                           fontFamily: fonts.poppins,
//                           color: colors.primary_dark,
//                           fontSize: isMobile ? size.smallText : size.text,
//                           "&:hover": { cursor: "pointer" },
//                         }}
//                         onClick={() => {
//                           userProfilePage();
//                         }}
//                       >
//                         {t("profile")}
//                       </Typography>
//                     </Box>
// 
//                     <Box
//                       sx={{
//                         display: "flex",
//                         flexDirection: "row",
//                         alignItems: "center",
//                         gap: 1,
//                       }}
//                     >
//                       <SupportAgent
//                         sx={{
//                           color: colors.primary_dark,
//                           fontSize: isMobile ? "20px" : "24px",
//                         }}
//                       />
//                       <Typography
//                         sx={{
//                           fontFamily: fonts.poppins,
//                           color: colors.primary_dark,
//                           fontSize: isMobile ? size.smallText : size.text,
//                           "&:hover": { cursor: "pointer" },
//                         }}
//                         onClick={() => {
//                           userSupporPage();
//                         }}
//                       >
//                         {t("support")}
//                       </Typography>
//                     </Box>
//                   </Box>
//                   <Divider />
//                   <Box
//                     sx={{
//                       display: "flex",
//                       flexDirection: "column",
//                       justifyContent: "flex-start",
//                       background: colors.background3,
//                       paddingLeft: isMobile ? 1 : 3,
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: "flex",
//                         flexDirection: "row",
//                         alignItems: "center",
//                       }}
//                     >
//                       <Moving
//                         sx={{
//                           color: colors.primary_dark,
//                           fontSize: isMobile ? "20px" : "24px",
//                         }}
//                       />
//                       <Button
//                         sx={{
//                           color: colors.primary_dark,
//                           fontFamily: fonts.poppins,
//                           fontSize: isMobile ? 14 : 16,
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           gap: 1,
//                           "&:hover": { cursor: "pointer" },
//                           textTransform: "none",
//                           padding: isMobile ? "4px 8px" : undefined,
//                         }}
//                         onClick={onUpgradePlansClick}
//                       >
//                         <Box
//                           sx={{
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             gap: 0.5,
//                             paddingTop: isMobile ? 0.5 : 1,
//                             paddingBottom: isMobile ? 0.5 : 1,
//                           }}
//                         >
//                           {t("upgrade")}
//                           <img
//                             src="crown.png"
//                             alt="logo"
//                             height={isMobile ? "16px" : "20px"}
//                             width={isMobile ? "16px" : "20px"}
//                           />
//                         </Box>
//                       </Button>
//                     </Box>
//                   </Box>
//                   <Divider />
// 
//                   <Box
//                     sx={{
//                       display: "flex",
//                       flexDirection: "column",
//                       justifyContent: "flex-start",
//                       background: colors.background3,
//                       paddingLeft: isMobile ? 1 : 2,
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: "flex",
//                         flexDirection: "row",
//                         justifyContent: "flex-start",
//                         alignItems: "center",
//                         padding: 1,
//                       }}
//                     >
//                       <Logout
//                         sx={{
//                           color: colors.primary_dark,
//                           fontSize: isMobile ? "20px" : "24px",
//                         }}
//                       />
//                       <Button
//                         onClick={handleSignOut}
//                         sx={{
//                           color: colors.primary_dark,
//                           fontFamily: fonts.poppins,
//                           fontSize: isMobile ? 14 : 16,
//                           padding: isMobile ? "4px 8px" : undefined,
//                           textTransform: "none",
//                         }}
//                       >
//                         {t("signout")}
//                       </Button>
//                     </Box>
//                   </Box>
//                 </Popover>
//               </>
//             )}
//           </PopupState>
//         )}
// 
//         {!userDetails && (
//           <Button
//             variant="contained"
//             sx={{ backgroundImage: colors.button, fontFamily: fonts.poppins }}
//           >
//             {t("login")}
//           </Button>
//         )}
//       </Stack>
//     </Box>
//   );
// }
// 
function SidebarFooter({ mini }) {
  const { t } = useTranslation();

  return (
    <Typography
      variant="caption"
      sx={{ m: 1, whiteSpace: "nowrap", overflow: "hidden" }}
    >
      {mini ? t("krushiSetu") : t("madeWithLove")}
    </Typography>
  );
}
SidebarFooter.propTypes = {
  mini: PropTypes.bool.isRequired,
};

const demoTheme = extendTheme({
  colorSchemes: { light: true },
  colorSchemeSelector: "class",
  typography: {
    fontFamily: 'var(--primary-font)',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 600,
      lg: 1200,
      xl: 1536,
    },
  },
});
const StyledDashboard = styled("div")({
  ".MuiPaper-root.MuiPaper-elevation.MuiPaper-elevation0.MuiDrawer-paper.MuiDrawer-paperAnchorLeft.MuiDrawer-paperAnchorDockedLeft":
  {
    maxWidth: "20% !important",
  },
  ".MuiDrawer-root.MuiDrawer-docked.css-1y8nxit-MuiDrawer-docked": {
    maxWidth: "20%",
  },
  ".MuiListItemIcon-root.css-1fx5hi-MuiListItemIcon-root svg": {
    color: "rgb(58, 58, 58)",
  },
  ".Mui-selected": {
    color: "var(--primary-dark-color) !important",
  },
  ".MuiPaginationItem-page.Mui-selected": {
    color: "white!important",
  },
  ".Mui-selected .MuiSvgIcon-root": {
    color: "#ffffff !important",
  },
  ".Mui-selected .MuiTypography-root": {
    color: "white !important",
  },
  ".MuiListItemButton-gutters .MuiTypography-root": {
    fontFamily: "var(--primary-font) !important",
    fontWeight: 600,
  },
  ".css-oc2eyy-MuiPaper-root-MuiDrawer-paper": {
    background: "linear-gradient(to right, #fffdd065, #fffdd065) !important",
  },
  ".css-gr4hu4-MuiPaper-root-MuiAppBar-root": {
    background: "linear-gradient(to right, #fffdd065, #fffdd065) !important",
  },
  ".css-oc2eyy-MuiPaper-root-MuiDrawer-paper": {
    border: "0px !important",
  },
  ".css-gr4hu4-MuiPaper-root-MuiAppBar-root": {
    border: "0px !important",
  },
  ".css-1093g50-MuiListItem-root": {
    marginBottom: "4px !important",
  },
  ".css-u6ogs3-MuiInputBase-root-MuiOutlinedInput-root": {
    paddingRight: "0px !important",
  },
});

const Dashboard = (props) => {
  const searchInputRef = React.useRef(null);
  const navigate = useNavigate();
  const { window } = props;
  const { t } = useTranslation();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const router = React.useMemo(() => ({
    pathname: location.pathname,
    searchParams: new URLSearchParams(location.search),
    navigate: (path) => navigate(path),
  }), [location, navigate]);
  const activePage = useActivePage();
  const { userData, setUserData, firebaseUser } = useUser();
  const [isAdmin, setIsAdmin] = React.useState(false);
  const [keyword, setKeyword] = useState("");
  const [isAutoFocusSearchOn, setIsAutoFocusSearchOn] = useState(false);
  const [isSeller, setIsSeller] = useState(false);
  const [isBuyer, setIsBuyer] = useState(false);
  // Define a function to update the router's pathname to "/search"
  const [searchInputFocused, setSearchInputFocused] = useState(false);
  const [role, setRole] = useState(null);
  const [purchasedPlots, setPurchasedPlots] = useState(null);
  const [isUserID, setIsUserID] = useState(null);

  const FetchPurchasedPlots = async () => {
    try {
      if (!userData?._id) return;
      const response = await fetch(
        `${url}/api/purchasedPlots/${userData?._id}`
      );
      if (!response.ok) return;
      const data = await response.json();
      setPurchasedPlots(data.purchasedPlots);
    } catch (error) {
      console.error("Error fetching purchased plots:", error);
    }
  };

  const focusSearchInput = React.useCallback(() => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [searchInputRef]);

  useEffect(() => {
    if (location.state && location.state.focusSearch) {
      focusSearchInput();
    }
    FetchPurchasedPlots();
  }, [location.state, focusSearchInput, userData]);



  const handleSearchInputClick = () => {
    if (router.pathname !== "/search") {
      router.navigate("/search");
    }
  };

  const handleNavItemClick = (item) => {
    if (item.path === '/home') {
      router.navigate(item.segment);
    } else {
      navigate(item.path);
    }
  };

  const handleSearchInputClickHome = () => {
    if (router.pathname !== "/search") {
      router.navigate("/search");
    }
  };
  // for upgrade plans page router /plans-pricing
  const handleUpgradePlans = () => {
    router.navigate("/plans-pricing");
  };
  const handleWishlistPage = () => {
    router.navigate("/wishlist/:userId");
  };
  const handleContactClick = () => {
    router.navigate("/carbon-credits");
  };
  const handleHoursClick = () => {
    router.navigate("/buyed-plans-seller");
  };
  const handleUserProfilePage = () => {
    navigate('/profile');
  };
  const handleListPlotPage = () => {
    router.navigate("/search");
  };
  const handleUserSupporPage = () => {
    router.navigate("/support");
  };
  const aboutUsPage = () => {
    router.navigate("/about");
  };
  const termsConditionPage = () => {
    router.navigate("/terms-conditions");
  };
  const faqsPage = () => {
    router.navigate("/faqs");
  };
  const refundPolicyPage = () => {
    router.navigate("/refund-policy");
  };
  const shippingPolicyPage = () => {
    router.navigate("/shipping-policy");
  };
  const cancellationPolicyPage = () => {
    router.navigate("/cancellation-policy");
  };
  const privacyPolicyPage = () => {
    router.navigate("/privacy-policy");
  };

  useEffect(() => {
    if (router.pathname == "/search") {
      setIsAutoFocusSearchOn(true);
    } else {
      setIsAutoFocusSearchOn(false);
    }
  }, [router.pathname]);

  // Admin and Role initialization based on context userData
  React.useEffect(() => {
    const isActuallyAdmin = userData?.role === 'Admin' || firebaseUser?.email === admin;
    setIsAdmin(isActuallyAdmin);
    
    if (userData) {
      setIsBuyer(userData.role === 'Buyer');
      setIsSeller(userData.role === 'Seller' || userData.role === 'Supplier');
      setIsUserID(userData._id);
      setRole(userData.role);
    }
  }, [userData, firebaseUser]);

  // navigation
  const NAVIGATION = [
    {
      segment: "dashboard",
      title: t("dashboard"),
      icon: <DashboardRounded />,
    },
    {
      segment: "search",
      title: t("search"),
      icon: <SearchRounded />,
    },
    ...(userData
      ? [
        {
          segment: "profile",
          title: t("profile"),
          icon: <PersonRounded />,
        },
      ]
      : []),
    ...(isAdmin
      ? [
        {
          segment: "list-buyers",
          title: "Buyers List",
          icon: <SpeakerNotes />,
        },
        {
          segment: "list-sellers",
          title: "Sellers List",
          icon: <SpeakerNotes />,
        },

        {
          segment: "list-all-plots",
          title: t("list-all-plots"),
          icon: <FeaturedPlayListRounded />,
        },
        {
          segment: "manage-crops",
          title: t("manage-categories"),
          icon: <CropRounded />,
        },

        {
          segment: "manage-plans",
          title: "Manage Plans",
          icon: <CardMembershipRounded />,
        },

        {
          segment: "manage-carbon-proofs",
          title: t("verify-carbon-proofs"),
          icon: <CloudQueueRounded />,
        },
        {
          segment: "manage-dashboard",
          title: "Manage Dashboard",
          icon: <DashboardRounded />,
        },
      ]
      : [
        ...(isSeller
          ? [
            {
              segment: "list-property",
              title: t("view-plot"),
              icon: <FeaturedPlayListRounded />,
            },
            {
              segment: "buyed-plans-seller",
              title: t("buyedPlans"),
              icon: <ShoppingBagRounded />,
            },
            {
              segment: "my-crops",
              title: "Crop Listing",
              icon: <AgricultureRounded />,
            },
            {
              segment: "carbon-credits",
              title: "Carbon Credits",
              icon: <CloudQueueRounded />,
            },
          ]
          : [
            {
              segment: "list-property",
              title: t("list-plot"),
              icon: <FeaturedPlayListRounded />,
            },
          ]),

        {
          segment: "plans-pricing",
          title: t("plans-pricing"),
          icon: <CardMembershipRounded />,
        },
        ...(isBuyer
          ? [
            {
              segment: "wishlist/:userId",
              title: t("wishlist"),
              icon: <FavoriteRounded />,
            },
            {
              segment: "viewed-plots/:userId",
              title: t("viewedPlots"),
              icon: <PageviewRounded />,
            },
            {
              segment: "buyed-plans",
              title: t("buyedPlans"),
              icon: <ShoppingBagRounded />,
            },
          ]
          : []),

        {
          segment: "terms-conditions",
          title: t("t&c"),
          icon: <GavelRounded />,
        },
        {
          segment: "privacy-policy",
          title: t("p&p"),
          icon: <ShieldRounded />,
        },
        {
          segment: "refund-policy",
          title: t("rfTitle"),
          icon: <ShieldRounded />,
        },
        {
          segment: "shipping-policy",
          title: t("spTitle"),
          icon: <LocalShipping />,
        },
        {
          segment: "cancellation-policy",
          title: t("cptitle"),
          icon: <GppBad />,
        },
        {
          segment: "faqs",
          title: t("faqs"),
          icon: <QuizRounded />,
        },
        {
          segment: "settings",
          title: t("settings"),
          icon: <SettingsRounded />,
        },
        {
          segment: "about",
          title: t("aboutUs"),
          icon: <InfoRounded />,
        },
        {
          segment: "support",
          title: t("support"),
          icon: <SupportAgentRounded />,
        },
      ]),
  ];

  const darkTheme = createTheme({
    palette: {
      mode: "dark",
    },
  });

  const renderPageContent = () => {
    switch (router.pathname) {
      // case "/home":
      //   return <Home userData={userData} />;
      case "/dashboard":
        return (
          <Home
            role={role}
            userData={userData}
            setUserData={setUserData}
            // handleUserProfilePage={handleUserProfilePage}
            handleListPlotPage={handleListPlotPage}
            aboutUsPage={aboutUsPage}
            termsConditionPage={termsConditionPage}
            privacyPolicyPage={privacyPolicyPage}
            faqsPage={faqsPage}
            refundPolicyPage={refundPolicyPage}
            shippingPolicyPage={shippingPolicyPage}
            cancellationPolicyPage={cancellationPolicyPage}
            supportPage={handleUserSupporPage}
            settingsPage={() => navigate('/settings')}
            wishlistPage={() => navigate('/wishlist')}
            viewedPlotsPage={() => navigate('/viewed-plots')}
          />
        );
      case "/searchbar":
        return (
          <SearchBar
            keyword={keyword}
            setKeyword={setKeyword}
            isAutoFocusSearchOn={isAutoFocusSearchOn}
            setIsAutoFocusSearchOn={setIsAutoFocusSearchOn}
          />
        );

      case "/search":
        return (
          <Search
            keyword={keyword}
            userData={userData}
            role={role}
            setUserData={setUserData}
          />
        );
      case "/list-property":
        return (
          <ListPlots
            userData={userData}
            setUserData={setUserData}
            handleUpgradePlans={handleUpgradePlans}
          />
        );
      case "/buyed-plans-seller":
        return (
          <PurchasedPlansSeller
            userData={userData}
            handleUpgradePlans={handleUpgradePlans}
          />
        );
      case "/carbon-credits":
        return (
          <CarbonCreditsDashboard
            userData={userData}
            onStartProject={() => router.navigate('/carbon-credits-farm-details')}
            onUploadProof={() => router.navigate('/carbon-credits-upload-proof')}
            onMyWallet={() => router.navigate('/carbon-credits-my-wallet')}
            onSellCredits={() => alert("Marketplace for selling credits is coming soon!")}
          />
        );
      case "/farmer-add-plot":
        return (
          <CropCategory />
        );
      case "/carbon-credits-farm-details":
        return (
          <CarbonCreditsFarmDetails
            userData={userData}
            onNext={() => router.navigate('/carbon-credits-practices')}
            onBack={() => router.navigate('/carbon-credits')}
          />
        );
      case "/carbon-credits-practices":
        return (
          <CarbonCreditsPractices
            userData={userData}
            onNext={() => router.navigate('/carbon-credits-timeline')}
            onBack={() => router.navigate('/carbon-credits-farm-details')}
          />
        );
      case "/carbon-credits-timeline":
        return (
          <CarbonCreditsTimeline
            userData={userData}
            onNext={() => router.navigate('/carbon-credits-review')}
            onBack={() => router.navigate('/carbon-credits-practices')}
          />
        );
      case "/carbon-credits-review":
        return (
          <CarbonCreditsReview
            userData={userData}
            onNext={() => router.navigate('/carbon-credits')}
            onBack={() => router.navigate('/carbon-credits-timeline')}
          />
        );
      case "/carbon-credits-upload-proof":
        return (
          <CarbonCreditsUploadProof
            userData={userData}
            onBack={() => router.navigate('/carbon-credits')}
          />
        );
      case "/manage-carbon-proofs":
        return isAdmin ? <CarbonCreditsManageProofs /> : <Home />;
      case "/carbon-credits-my-wallet":
        return (
          <CarbonCreditsMyWallet
            userData={userData}
            onBack={() => router.navigate('/carbon-credits')}
          />
        );
      case "/my-crops":
        return <MyCrops userData={userData} />;
      case "/add-crop-step-1":
        return <CropCategory userData={userData} />;
      case "/pricing":
        return <Pricing userData={userData} />;
      case "/photos":
        return <Photos userData={userData} />;
      case "/location-delivery":
        return <LocationDelivery userData={userData} />;
      case "/manage-crops":
        return isAdmin ? <ManageCropCategory /> : <Home />;
      case "/manage-plans":
        return isAdmin ? <ManagePlans /> : <Home />;
      case "/free-plans":
        return isAdmin ? <FreePlans /> : <Home />;
      case "/manage-dashboard":
        return isAdmin ? <ManageDashboard /> : <Home />;
      // case "/view-plot":
      case "/list-buyers":
        return isAdmin ? <ListBuyers userData={userData} /> : <Home />;
      case "/list-sellers":
        return isAdmin ? <ListSellers /> : <Home />;
      case "/list-all-plots":
        // return isAdmin ? <ListAllPlots /> : <Home />;
        return isAdmin ? <ListPlots userData={userData} /> : <Home />;

      // case "/signup":
      case "/plans-pricing":
        return (
          <PlansPricing
            userData={userData}
            setUserData={setUserData}
          />
        );
      case "/buyed-plans":
        return (
          <PurchasedPlans
            userData={userData}
            handleUpgradePlans={handleUpgradePlans}
          />
        );
      case "/profile":
        return <Profile userData={userData} />;
      case "/wishlist":
      case "/wishlist/:userId":
        return (
          <Wishlist
            userData={userData}
            role={role}
            setUserData={setUserData}
            handleListPlotPage={handleListPlotPage}
          />
        );
      case "/viewed-plots/:userId":
        return (
          <ViewedPlots
            userData={userData}
            handleListPlotPage={handleListPlotPage}
          />
        );
      case "/settings":
        return (
          <Settings
            userData={userData}
            role={role}
            setUserData={setUserData}
            isUserID={isUserID}
          />
        );
      case "/about":
        return <About />;
      case "/support":
        return <Support faqsPage={faqsPage} />;
      case "/terms-conditions":
        return <TermsAndCondition />;
      case "/privacy-policy":
        return <PrivacyPolicy />;
      case "/refund-policy":
        return <RefundPolicy />;
      case "/shipping-policy":
        return <ShippingPolicy />;
      case "/cancellation-policy":
        return <CancellationPolicy />;
      case "/faqs":
        return <FAQs />;
      default:
        return isAdmin ? (
          <AdminHome />
        ) : (
          <Home
            role={role}
            userData={userData}
            setUserData={setUserData}
            searchInputRef={searchInputRef}
            router={router}
            onSearchInputClick={handleSearchInputClick}
            // handleUserProfilePage={handleUserProfilePage}
            handleListPlotPage={handleListPlotPage}
            aboutUsPage={aboutUsPage}
            termsConditionPage={termsConditionPage}
            privacyPolicyPage={privacyPolicyPage}
            faqsPage={faqsPage}
            refundPolicyPage={refundPolicyPage}
            shippingPolicyPage={shippingPolicyPage}
            cancellationPolicyPage={cancellationPolicyPage}
            supportPage={handleUserSupporPage}
            settingsPage={() => navigate('/settings')}
            wishlistPage={() => navigate('/wishlist')}
            viewedPlotsPage={() => navigate('/viewed-plots')}
          />
        );
    }
  };

  return (
    <StyledDashboard>
      <AppProvider
        // navigation={NAVIGATION}
        router={router}
        theme={demoTheme}
      // branding={{
      //   logo: (
      //     <img
      //       src={isMobile ? "krushisetuLogomark.png" : `${KrushiSetu}`}
      //       alt="logo"
      //       style={{
      //         objectFit: "contain",
      //         height: isMobile ? "70px" : "100px", // Optional: adjust height for mobile
      //       }}
      //     />
      //   ),
      //   title: <Typography></Typography>,
      // }}
      >
        {/* <DashboardLayout
          hideNavigation
          slots={{
            toolbarActions: () => (
              <HeaderNav
                onSearchInputClick={handleSearchInputClick}
                onSearchInputClickHome={handleSearchInputClickHome}
                keyword={keyword}
                setKeyword={setKeyword}
                isAutoFocusSearchOn={isAutoFocusSearchOn}
                onUpgradePlansClick={handleUpgradePlans}
                onWishlistClick={handleWishlistPage}
                userProfilePage={handleUserProfilePage}
                userSupporPage={handleUserSupporPage}
                inputRef={searchInputRef}
                onContactClick={handleContactClick}
                onHoursClick={handleHoursClick}
                onFindNowClick={handleListPlotPage}
              />
            ),

            sidebarFooter: SidebarFooter,
          }}
        > */}
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', width: '100%', backgroundColor: colors.background_light || '#FFFFFF' }}>
          <Box component="main" sx={{ flexGrow: 1 }}>
            {renderPageContent()}
          </Box>
        </Box>
        {/* </DashboardLayout> */}
      </AppProvider>
    </StyledDashboard>
  );
};

export default Dashboard;
